import React from 'react';
import withIcon from '../utilities/withIcon';

const IconMinus = () => {
  return (
    <g>
      <path d="M1.75 7.25h12.5a.75.75 0 1 1 0 1.5H1.75a.75.75 0 0 1 0-1.5z" />
    </g>
  );
};

export default withIcon(IconMinus);
